var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Guid } from "../../../utilities/guid";
import { bindable } from "aurelia-templating";
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
var FileUploader = /** @class */ (function () {
    function FileUploader(element, notificationClientService) {
        this.element = element;
        this.notificationClientService = notificationClientService;
        this.identifier = Guid.generateGuid();
        this.placeholder = "";
        this.value = "";
        this.accept = "";
        this.info = "";
    }
    FileUploader.prototype.remove = function () {
        if (this.fileInput)
            this.fileInput.value = "";
        this.filesInternal = null;
        this.uri = "";
        this.value = "";
        this.dataUri = "";
        this.element.dispatchEvent(new CustomEvent("on-file-attached", {
            bubbles: true,
            detail: {
                files: null,
                innerEvent: null
            }
        }));
    };
    Object.defineProperty(FileUploader.prototype, "uri", {
        get: function () {
            var _this = this;
            if (this.value && !this.filesInternal)
                return this.value;
            if (this.filesInternal && this.filesInternal.length > 0)
                return Enumerable.from(this.filesInternal.length).select(function (x) { return _this.filesInternal.item(x - 1).name; }).toArray().join(", ");
            return this._uri;
        },
        set: function (x) {
            this.value = null;
            this.filesInternal = null;
            this._uri = x;
            this.dataUri = x;
        },
        enumerable: false,
        configurable: true
    });
    FileUploader.prototype.attached = function () {
        var _this = this;
        var self = this;
        $(this.element).find("input:file").change(function ($event) {
            var ele = $(self.element).find("input:file").get(0);
            if (_this.checkCorrectFileTypes(ele)) {
                self.readURL(ele, self);
                self.files = [].slice.call(ele.files);
                _this.element.dispatchEvent(new CustomEvent("on-file-attached", {
                    bubbles: true,
                    detail: {
                        files: ele.files,
                        innerEvent: $event
                    }
                }));
            }
            else {
                self.remove();
                _this.notificationClientService.show("Error", "The file uploaded is not supported", NotificationType.Error);
            }
        });
    };
    FileUploader.prototype.checkCorrectFileTypes = function (ele) {
        if (ele.files.length > 0) {
            var acceptList = this.accept != "" ? this.accept.split(',') : [];
            var acceptedFileTypeList = Enumerable.from(acceptList).select(function (x) { return x.trim(); });
            var correctFileType = false;
            for (var i = 0; i < ele.files.length; i++) {
                correctFileType = acceptedFileTypeList.count() > 0 ? acceptedFileTypeList.contains(ele.files[i].type) : true;
            }
            return correctFileType;
        }
        return false;
    };
    FileUploader.prototype.readURL = function (input, self) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            reader.onload = function (e) {
                self.dataUri = e.target.result;
            };
            reader.readAsDataURL(input.files[0]);
        }
    };
    FileUploader.prototype.reset = function () {
        if (this.fileInput) {
            $(this.fileInput).val('');
        }
    };
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], FileUploader.prototype, "identifier", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], FileUploader.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], FileUploader.prototype, "placeholder", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], FileUploader.prototype, "value", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], FileUploader.prototype, "multiple", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], FileUploader.prototype, "readonly", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], FileUploader.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], FileUploader.prototype, "accept", void 0);
    __decorate([
        bindable,
        __metadata("design:type", FileList)
    ], FileUploader.prototype, "files", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], FileUploader.prototype, "dataUri", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], FileUploader.prototype, "info", void 0);
    FileUploader = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element, NotificationClientService])
    ], FileUploader);
    return FileUploader;
}());
export { FileUploader };
